import React, { useCallback } from 'react';

export type OptionLike = {
  label?: React.ReactNode;
  value?: string | number | null;
  children?: React.ReactNode;
};

export const useFilterOption = () => {
  const filterOption = useCallback(
    (inputValue: string, option?: OptionLike) => {
      const labelText = extractText(option?.label);
      const childrenText = extractText(option?.children);
      const textToMatch = labelText || childrenText;

      return textToMatch
        .toLowerCase()
        .includes(String(inputValue).toLowerCase());
    },
    [],
  );

  function extractText(node: React.ReactNode | undefined): string {
    if (!node) return '';
    if (typeof node === 'string' || typeof node === 'number')
      return String(node);
    if (Array.isArray(node)) return node.map((n) => extractText(n)).join('');
    if (React.isValidElement<{ children?: React.ReactNode }>(node)) {
      return extractText(node.props.children);
    }
    return '';
  }

  return filterOption;
};
